module.exports = __webpack_public_path__ + "static/media/cr.657d7dbc.svg";